import Questions from './Questions';

export default Questions;


// WEBPACK FOOTER //
// /src/components/commonComponents/surveyView/questions/index.js